import clsx from "clsx";

import { QuestionLinear } from "@monta/icons";

import type { FC } from "react";
import type { TableTooltipProps, ListItemData } from "./types";

const ListItem: FC<{ item: ListItemData; index: number }> = ({
  item,
  index
}) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col items-start justify-between gap-2">
        <span className="text-xs text-neutral-700 font-semibold flex-1 whitespace-nowrap">
          <span className="ml-1">{index + 1} -</span>
          {item.text}
        </span>

        {item.secondaryText && (
          <span className="text-xs font-semibold text-[#1054D2] whitespace-nowrap">
            {item.secondaryText}
          </span>
        )}

        {item.description && (
          <p className="text-xs text-[#667085]">{item.description}</p>
        )}
      </div>
    </div>
  );
};

const TableTooltip: React.FC<TableTooltipProps> = ({
  title = "",
  items = [],
  className = ""
}) => {
  return (
    <div className={clsx("bg-white lg:shadow-2xl rounded-2 lg:p-6", className)}>
      {/* Header */}
      <div className="flex items-center w-full justify-between border-b border-[#EAECF0] lg:border-none lg:pb-0 pb-4">
        <div className="flex justify-center lg:justify-start w-full gap-2 cursor-pointer">
          <QuestionLinear size={16} className="lg:flex hidden" />

          <h3 className="text-sm font-semibold text-[#1D2939]  relative lg:before:hidden before:w-10 before:h-1 before:bg-[#CCCCCC] before:rounded-[10px] before:absolute before:-top-5 before:right-1/2 before:translate-1/2">
            {title}
          </h3>
        </div>
      </div>

      {items.length > 0 ? (
        <div className="flex flex-col gap-6 mt-5">
          {items.map((item, index) => (
            <ListItem key={`${item.text}-${index}`} item={item} index={index} />
          ))}
        </div>
      ) : (
        <div className="p-4 text-center text-gray-500 text-sm">
          موردی برای نمایش وجود ندارد
        </div>
      )}
    </div>
  );
};

export default TableTooltip;
